/* 19/10 : « le petit plus » du tiroir panier (snippets/mf-cart-upsell) : ajout en un clic, puis le tiroir se redessine
   comme après un ajout depuis une fiche (même réponse « sections » que product-form.js de Dawn). */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.mf-upsell__add');
  if (!btn || btn.disabled) return;
  btn.disabled = true;
  btn.classList.add('is-loading');
  const drawer = document.querySelector('cart-drawer');
  try {
    const res = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`.replace('.js.js', '.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message);
    // sur la page panier, on recharge la page (le tiroir n'est pas affiché)
    if (drawer && data.sections && !document.getElementById('main-cart-items')) drawer.renderContents({ ...data, id: data.items ? data.items[0].id : data.id });
    else window.location.reload();
  } catch (err) {
    btn.disabled = false;
    btn.classList.remove('is-loading');
    console.error('Ajout du porte-clés impossible', err);
  }
});
